import { DIMENSION_IDS } from '@/constants'
import { createListQuery } from '../utils'
import { createSharedComposable } from '@vueuse/core'
import { useDimension } from './dimension'
import { usePrevalenceUnit } from './prevalence-unit'

export const useViewMode = createSharedComposable(() => {
    const dimension = useDimension()
    const [prevalenceUnit] = usePrevalenceUnit()

    return createListQuery('view-mode', () => {
        return unref(dimension) === DIMENSION_IDS.PREVALENCE &&
            unref(prevalenceUnit) === 'absolute'
            ? [
                  {
                      label: 'Treemap Chart',
                      value: 'treemap'
                  },
                  {
                      label: 'Bar Chart',
                      value: 'bar'
                  }
              ]
            : [
                  {
                      label: 'Bubble Chart',
                      value: 'bubble'
                  },
                  {
                      label: 'Map',
                      value: 'map'
                  }
              ]
    })
})
